import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from './PrimaryButton';

class DownloadOptionButton extends React.Component {

    state = {
        open: false
    };

    showMenu = (ev) => {
        this.setState({
            anchorEl: ev.currentTarget,
            open: true
        });
    };

    handleClose = (format) => {
        this.setState({ open: false });
        if (format !== null) this.props.onSelect(format);
    };

    render() {

        const { disabled } = this.props;
        const { open, anchorEl } = this.state;

        return (
            <div>
                <PrimaryButton
                    disabled={disabled}
                    dataTest="download-options"
                    endIcon={<KeyboardArrowDownIcon />}
                    onClick={this.showMenu}>Download</PrimaryButton>
                <Menu
                    open={open}
                    anchorEl={anchorEl}
                    transformOrigin={{
                        horizontal: -5,
                        vertical: -46
                    }}
                    onClose={(ev) => {
                        ev.preventDefault();
                        ev.stopPropagation();
                        this.handleClose(null);
                    }}>
                    <MenuItem
                        data-test={"item-csv"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("csv");
                        }}
                        value="csv">CSV</MenuItem>
                    <MenuItem
                        data-test={"item-html"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("html");
                        }}
                        value="html">HTML</MenuItem>
                    <MenuItem
                        data-test={"item-tsv"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("tsv");
                        }}
                        value="tsv">TSV</MenuItem>
                    <MenuItem
                        data-test={"item-xlsx"}
                        dense={true}
                        onClick={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            this.handleClose("xlsx");
                        }}
                        value="xlsx">XLSX (Excel)</MenuItem>
                </Menu>
            </div>
        );
    }
}

DownloadOptionButton.defaultProps = {
    disabled: false
};

DownloadOptionButton.propTypes = {
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired
};

export default DownloadOptionButton;